if (!customElements.get('jjc-hero-deck')) {
  class JJCHeroDeck extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.tabs = Array.from(this.querySelectorAll('[data-hero-tab]'));
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay !== 'false';
      this.delay = Math.max(5, Number(this.dataset.changeSeconds) || 8) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.bindEvents();
      this.showSlide(0, false);
      this.startTimer();
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.showSlide(index, true)));
      this.querySelector('[data-hero-previous]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.step(1));
      this.addEventListener('pointerenter', () => this.stopTimer());
      this.addEventListener('pointerleave', () => this.startTimer());
      this.addEventListener('focusin', () => this.stopTimer());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.startTimer();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });
      this.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; });
      this.addEventListener('pointerup', (event) => {
        if (!Number.isFinite(this.pointerStart)) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) > 55) this.step(distance > 0 ? -1 : 1);
      });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide.contains(event.target));
        if (index >= 0) this.showSlide(index, true);
      });
    }

    showSlide(index, userInitiated) {
      if (!this.slides.length) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === this.currentIndex;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      if (userInitiated) {
        this.stopTimer();
        this.startTimer();
      }
    }

    step(direction) {
      this.showSlide(this.currentIndex + direction, true);
    }

    startTimer() {
      if (!this.autoplay || this.reducedMotion || this.slides.length < 2 || this.matches(':hover') || this.contains(document.activeElement)) return;
      this.stopTimer();
      this.timer = window.setInterval(() => this.showSlide(this.currentIndex + 1, false), this.delay);
    }

    stopTimer() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('jjc-hero-deck', JJCHeroDeck);
}
